import React from "react";
import AdminCatalogModulesRoutes from "./AdminCatalogModulesRoutes";

import { useTracking } from "react-tracking";
import { useDispatch, useSelector } from "react-redux";
import { startRegisterTrackingHistory } from "../../app/actions/trackingHistoryActions";

const AdminCatalogModulesScreen = () => {
  const dispatch = useDispatch();
  const { user } = useSelector((state) => state.auth);

  const { Track } = useTracking(
    {
      module: "Administration Catalog Modules",
      page: "Admin Catalog Modules Screen",
      user_id: user.user_id,
      user_name: user.user_name,
      
    },
    {
      dispatch: (data) => {

        dispatch(startRegisterTrackingHistory(data));
        
      },
    }
  );

  return (
    <div>
      <Track>
        <AdminCatalogModulesRoutes />
      </Track>
    </div>
  );
};

export default AdminCatalogModulesScreen;
